// extracted by mini-css-extract-plugin
export default {"notes":"e3Ooz","notesLabel":"ydQwE","notesText":"xOlOa"};